import moment from 'moment';
import get from 'lodash/get';

/** @description checks for Day Of the week */
export default function dow(gluValue, { dow, offset }) {
  const value = get(gluValue, 'startDate') || get(gluValue, 'endDate') || gluValue;
  const valueDOW = moment(value).format('E');
  const daysAllowed = [].concat(dow).map(String);
  const offsetAdd = offset && String(Number(moment(value).format('e')) + offset);

  /**
   * @example
   * Math.abs(7 - Math.abs(value + offset))
   * Math.abs(7 - Math.abs( 5 + -2 ))
   * => 4
   * Math.abs(7 - Math.abs( 5 + 3 ))
   * => 1
   */
  const offsetValue =
    offsetAdd > 7 || offsetAdd <= 0 ? Math.abs(7 - Math.abs(offsetAdd)) : offsetAdd;

  // `E` `1..7` ISO day of week
  if (!daysAllowed.includes(offsetValue || valueDOW)) {
    return 'Day of the week is not allowed';
  }

  return null;
}
